import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mat-barcode",
  "use": "icon-soc-mat-barcode-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mat-barcode\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<path d=\"M192 256h64v512H192zM288 256h32v512h-32zM352 256h80v512H352zM464 256h32v512h-32zM528 256h96v512H528zM656 256h32v512h-32zM720 256h112v512H720z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mat-barcode.svg
// module id = OH8k
// module chunks = 478